import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from '@unicus/react-ui-kit';
import {
  LEDGERACCOUNT,
  LEDGERACCOUNT_FILE_IMPORT,
  LEDGERACCOUNT_FILE_IMPORT_FINISHED
} from './ledgerAccountActions';

const handleError = (state, action) => {
  const errors =
    action.payload && action.payload.errors ? action.payload.errors || [] : [];

  return updateResourceState(state, action, RESOURCE, () => ({
    saving: false,
    loading: false,
    importingFile: false,
    errors
  }));
};

const ledgerAccountReducer = createResourceReducer(
  LEDGERACCOUNT,
  [],
  {
    [LEDGERACCOUNT_FILE_IMPORT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        importingFile: true
      }));
    },

    [LEDGERACCOUNT_FILE_IMPORT_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false,
        importingFile: false
      }));
    }
  },
  handleError
);

export default ledgerAccountReducer;
